import { trans } from '@spotahome/soyuz/client';

import './NoDataAvailable.scss';

const NoDataAvailable = () => (
  <div className="charts-no-data">
    <p>{trans('charts.no.data')}</p>
  </div>
);

export default NoDataAvailable;
